(function () {
  function initOne(config) {
    var bar = document.getElementById('ss-sticky-bar-' + config.barId);
    var priceMirror = document.getElementById('ss-sticky-bar-price-' + config.barId);
    var sizeMirror = document.getElementById('ss-sticky-bar-size-' + config.barId);
    var cta = document.getElementById('ss-sticky-bar-cta-' + config.barId);
    var sourceButton = document.querySelector(config.buttonSelector);
    var anchor = document.querySelector(config.anchorSelector);

    if (!bar || !cta || !sourceButton || !anchor) return;

    /*
     * Dawn's price markup keeps both the regular-price and sale-price
     * variants (plus screen-reader-only "Regular price"/"Sale price"
     * labels and Sale/Sold out badges) in the DOM at all times, only
     * toggling which one is visible via CSS -- .textContent doesn't
     * know about that and concatenates all of it. Walk the tree and
     * only collect text actually rendered right now.
     */
    function isHidden(el) {
      if (el.classList && el.classList.contains('visually-hidden')) return true;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
      if (el.offsetParent === null && style.position !== 'fixed' && style.position !== 'sticky') return true;
      return false;
    }

    function getVisibleText(el) {
      if (isHidden(el)) return '';
      var text = '';
      el.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          text += node.textContent;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          text += getVisibleText(node);
        }
      });
      return text;
    }

    function syncText(selector, target) {
      if (!selector || !target) return;
      var el = document.querySelector(selector);
      if (!el) return;
      var text = getVisibleText(el).replace(/\s+/g, ' ').trim();
      if (text) target.textContent = text;
    }

    function syncPrice() {
      syncText(config.priceSelector, priceMirror);
    }

    function syncSize() {
      syncText(config.variantSelector, sizeMirror);
    }

    syncPrice();
    syncSize();

    var priceEl = config.priceSelector ? document.querySelector(config.priceSelector) : null;
    if (priceEl) {
      new MutationObserver(syncPrice).observe(priceEl, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    var sizeEl = config.variantSelector ? document.querySelector(config.variantSelector) : null;
    if (sizeEl) {
      new MutationObserver(syncSize).observe(sizeEl, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    function syncButtonState() {
      var disabled =
        sourceButton.hasAttribute('disabled') || sourceButton.getAttribute('aria-disabled') === 'true';
      cta.disabled = disabled;
      cta.classList.toggle('is-disabled', disabled);
    }
    syncButtonState();
    new MutationObserver(syncButtonState).observe(sourceButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    cta.addEventListener('click', function () {
      sourceButton.click();
    });

    if ('IntersectionObserver' in window) {
      var anchorVisible = false;
      var footerVisible = false;

      function render() {
        var shouldShow = !anchorVisible && !footerVisible;
        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            anchorVisible = entry.isIntersecting;
          });
          render();
        },
        { rootMargin: '0px' }
      ).observe(anchor);

      var footer = document.querySelector('.footer, footer');
      if (footer) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              footerVisible = entry.isIntersecting;
            });
            render();
          },
          { rootMargin: '0px' }
        ).observe(footer);
      }
    }
  }

  function init() {
    (window.ssStickyBarConfigs || []).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
